var render = function render(){var _vm=this,_c=_vm._self._c;return _c('login-wrapper',[_c('h2',{staticClass:"text-center p-5"},[_vm._v(" Redirecting "),_c('icon',{attrs:{"name":"spinner","spin":"","custom-class":"ml-3"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }